<ng-container [ngSwitch]="section.type">

  <card-text *ngSwitchCase="'text'" [text]="asText(section).text"></card-text>

  <card-text
    *ngSwitchCase="'callout'"
    [callout]="asCallout(section).text"
    [accent]="asCallout(section).accent">
  </card-text>

  <card-insight
    *ngSwitchCase="'insight'"
    [severity]="asInsight(section).severity"
    [headline]="asInsight(section).headline"
    [observation]="asInsight(section).observation"
    [insightAction]="asInsight(section).action"
    [tools]="asInsight(section).tools"
    [actions]="asInsight(section).actions"
    (action)="action.emit($event)">
  </card-insight>

  <card-metric
    *ngSwitchCase="'metric'"
    [label]="asMetric(section).label"
    [value]="asMetric(section).value"
    [delta]="asMetric(section).delta"
    [trend]="asMetric(section).trend">
  </card-metric>

  <card-stats
    *ngSwitchCase="'stats'"
    [title]="asStats(section).title"
    [items]="asStats(section).items">
  </card-stats>

  <card-chart
    *ngSwitchCase="'chart'"
    [variant]="asChart(section).variant"
    [title]="asChart(section).title"
    [unit]="asChart(section).unit"
    [seriesLabels]="asChart(section).seriesLabels"
    [items]="asChart(section).items">
  </card-chart>

  <card-progress
    *ngSwitchCase="'progress'"
    [variant]="asProgress(section).variant"
    [title]="asProgress(section).title"
    [label]="asProgress(section).label"
    [percent]="asProgress(section).percent"
    [detail]="asProgress(section).detail"
    [steps]="asProgress(section).steps"
    [bars]="asProgress(section).bars">
  </card-progress>

  <card-list
    *ngSwitchCase="'list'"
    [title]="asList(section).title"
    [items]="asList(section).items">
  </card-list>

  <card-facts
    *ngSwitchCase="'facts'"
    [title]="asFacts(section).title"
    [items]="asFacts(section).items">
  </card-facts>

  <card-entities
    *ngSwitchCase="'entities'"
    [title]="asEntities(section).title"
    [items]="asEntities(section).items"
    (openEntity)="openEntity.emit($event)">
  </card-entities>

  <card-timeline
    *ngSwitchCase="'timeline'"
    [title]="asTimeline(section).title"
    [items]="asTimeline(section).items">
  </card-timeline>

</ng-container>
